import { createSlice } from "@reduxjs/toolkit";

export const activityHistorySlice = createSlice({
    name: 'activityHistory',
    initialState: {
        value: undefined
    },
    reducers: {
        setActivityHistory: (state, action) => {
            state.value = action.payload;
        }
    }
})

export const { setActivityHistory } = activityHistorySlice.actions;

export const getActivityHistory = (state) => state.activityHistory.value;

export default activityHistorySlice.reducer;